import { useContext, useEffect, useMemo, useState } from "react";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../../utils/hooks/useActionCallback";
import {
  LENDER_APPROVAL_STATUS,
  LOAN_APPLICATION_STATE,
} from "../../../../../../config/config";

const MAX_RETRIES = 6;
const RETRY_DELAY = 3000;

export const useLenderSelection = () => {
  const {
    state: { loan, loanApplications },
    dispatch,
  } = useContext(ProcessContext);

  const [retries, setRetries] = useState(0);

  const areAllLoanApplicationsDenied = useMemo(
    () =>
      loanApplications.every(
        (loanApplication) =>
          loanApplication.lender_fields.loan_application_status
            .lender_approval_status === LENDER_APPROVAL_STATUS.NO
      ),
    [loanApplications]
  );

  useEffect(() => {
    if (areAllLoanApplicationsDenied) {
      handleSubmit(loanApplications[0]);
    }
  }, [areAllLoanApplicationsDenied]);

  const getLoan = () => {
    dispatch({
      type: "REQUEST_GET_LOAN",
      payload: loan.id,
    });
  };

  const patchSyncDocumentation = () => {
    dispatch({
      type: "REQUEST_PATCH_SYNC_BORROWER_DOCUMENTATION_BY_LOAN_ID",
      payload: {
        op: "processPatchSyncBorrowerDocumentationByLoanId",
        id: loan.id,
      },
    });
  };

  useActionCallback("REQUEST_POST_MANUAL_CHOOSE_FULFILLED", () => {
    getLoan();
  });

  useActionCallback("REQUEST_GET_LOAN_FULFILLED", () => {
    patchSyncDocumentation();
  });

  useActionCallback(
    "REQUEST_PATCH_SYNC_BORROWER_DOCUMENTATION_BY_LOAN_ID_REJECTED",
    () => {
      if (retries < MAX_RETRIES) {
        setRetries(retries + 1);
        setTimeout(patchSyncDocumentation, RETRY_DELAY);
      } else {
        dispatch({
          type: "SET_FLOW_ITEM_OK",
        });
      }
    }
  );

  useActionCallback(
    "REQUEST_PATCH_SYNC_BORROWER_DOCUMENTATION_BY_LOAN_ID_FULFILLED",
    () => {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
    }
  );

  const handleSubmit = (loanApplication) => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });

    if (
      loanApplication.lender_fields.loan_application_status.state ===
      LOAN_APPLICATION_STATE.SELECTED
    ) {
      getLoan();
      return;
    }

    dispatch({
      type: "REQUEST_POST_MANUAL_CHOOSE",
      payload: {
        loanId: loan.id,
        loanApplicationId: loanApplication.id,
      },
    });
  };

  return { handleSubmit, areAllLoanApplicationsDenied };
};
